export const EFeedViewActions = {
  CHANGE_FILTER: 'feed/CHANGE_FILTER',
};

export const updateFeedSearch = changes => ({
  type: EFeedViewActions.CHANGE_FILTER,
  ...changes,
});
